export default () => {
  const cards = document.querySelectorAll('[component="showcase-card"]');

  cards.forEach((card) => {
    const contentChild = card.querySelector('[child="content"]');

    if (contentChild) {
      const { borderColor, backgroundColor, textColor } = contentChild.dataset;

      if (borderColor) {
        contentChild.style.borderColor = borderColor;
      }

      if (backgroundColor) {
        contentChild.style.backgroundColor = backgroundColor;
      }

      if (textColor) {
        contentChild.style.color = textColor;
      }
    }
  });
};
